import React, { useEffect, useRef, useState } from "react";
import { Input, Button, Image, Table, Select, Modal, DatePicker, message, Checkbox, QRCode, TimePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {API_BASE_URL_ISSUER} from "../services/apiConfig";
import AuthService from "../services/auth.service";
import { ConsoleSqlOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from "dayjs";
import html2canvas from 'html2canvas';
interface ClubInfo {
    club_seq: number;
    club_name: string;
    valid: boolean;
    club_category_seq: number;
    agentSeq: number;
}

interface FormlistView {
    SelectValue: string;
    selectedClubInfo: ClubInfo | null;
    selectmemberidsoket: any;
    onselectedDeviceNameChange: (selectedDeviceName: any) => void;
    onselectchangeupdate: (selectchangeroom: any) => void;
    profiledata: any;
}
interface Question {
    name: string;
    input: { [key: string]: string | boolean }[]; // 답변 배열
    type: 'single' | 'multi' | 'input'; // 선택 모드
}
const FormlistView: React.FC<FormlistView> = ({
    SelectValue,
    selectedClubInfo,
    selectmemberidsoket,
    onselectedDeviceNameChange,
    profiledata,
    onselectchangeupdate,
}) => {
    const [agentsettingdeviceName, setagentsettingdeviceName] = useState<any>([]);
    const [selectedOption1, setSelectedOption1] = useState<string>("option1");
    const [initialData, setInitialData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [excelData, setExcelData] = useState<any[]>([]);
    const [duesexcelData, setduesexcelData] = useState<any[]>([]);
    const [tempexcelData, settempexcelData] = useState<any[]>([]);
    const [searchOption, setSearchOption] = useState<string>("회원명");
    const [width, setWidth] = useState(window.innerWidth);
    const [contentLength, setcontentLength] = useState<string>("");
    const [token, settoken] = useState<string | null>(null);
    const [addition, setaddition] = useState(0);
    const [membercount, setmembercount] = useState<number>(0);
    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
    const [selectedRowData, setSelectedRowData] = useState<any[] | null>(null);
    const [selectedValue, setSelectedValue] = useState("");
    const [SelectHeaderValue, setSelectHeaderValue] = useState<string | null>(
        null
    );
    const [selectedRow, setSelectedRow] = useState<any | null>(null);
    const [modalVisible, setModalVisible] = useState(false);

    const [selectAgentClubFormDataSeq, setselectAgentClubFormDataSeq] = useState<number>(0);
    const [selectMemberDidSeq, setselectMemberDidSeq] = useState<number>(0);
    const [formlistDetailData, setFormlistDetailData] = useState<any | null>(null);
    const [selectmethodvalue, setSelectMethodValue] = useState('');
    const [editedPanel, setEditedPanel] = useState(null);
    const [QQrmodalOpen, setQQrModalOpen] = useState(false);
    const [expandedDevice, setExpandedDevice] = useState(null);
    const [newqrdevice, setnewqrdevice] = useState("");
    const [userSymptoms, setUserSymptoms] = useState<any[]>([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [selectdid, setselectdid] = useState<string>("");
    const [typeselectionMode, settypeSelectionMode] = useState<'type1' | 'type2'>('type1');
    const [type, setType] = useState<string[]>(['single']);
    const [selectqrdevicename, setselectqrdevicename] = useState("");
    const [answers, setAnswers] = useState<string[][]>([[]]);
    const [questions, setQuestions] = useState<string[]>(['']);
    const [questionsView, setQuestionsView] = useState<Question[]>([]);
    const [webagentsettingrowdataform, setwebagentsettingrowdataform] = useState<any[]>([]);
    const [Qrlasttime, setQrlasttime] = useState('');
    const [Qrlasttimetime, setQrlasttimetime] = useState('');
    const [agentsettingalldata, setagentsettingalldata] = useState<any>([]);
    const [qrdata, setqrdata] = useState<any>("");
    const [qrLinkSeq, setqrLinkSeq] = useState<any>("");
    const [selectdeviceid, setselectdeviceid] = useState("");
    const [typeselectedItems, settypeSelectedItems] = useState<number[]>([]);
    const [etcAnswers, setEtcAnswers] = useState<string[]>([]);
    const [selectformdeviceID, setselectformdeviceID] = useState("");
    const [selectformdeviceName, setselectformdeviceName] = useState("");
    const [webagentsettingrowdata, setwebagentsettingrowdata] = useState<any[]>([]);
    const [selectionModes, setSelectionModes] = useState<Array<'single' | 'multi' | 'input'>>(['single']);
    const [userRooms, setUserRooms] = useState<any[]>([]);
    const [lastdate, setlastdate] = useState<dayjs.Dayjs | null>(null); // Dayjs 형식으로 상태 정의
    const [qrprintmodalOpen, setqrprintmodalOpen] = useState(false);
    const qrRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const rawToken = AuthService.getRawToken();
        settoken(rawToken);
    }, []);
    useEffect(() => {
        // if (token !== null && profiledata.length > 0) {
        const profileData = profiledata[0];
        setselectdid(profileData.memberDid);
        // }
    }, [profiledata]);
    useEffect(() => {
        if (token !== null) {
            fetchFormlistDetailDataAPI();
        }
    }, [selectAgentClubFormDataSeq]);

    useEffect(() => {
        fetchFormlistDataAPI();
    }, []);
    useEffect(() => {

        if (token !== null && selectedClubInfo?.club_seq !== 0) {
            fetchwaitagentSettingDataAPI();
            fetchWebAgentSettinglist();
        }

    }, [token, selectedClubInfo?.club_seq]);

    const handleAnswerChange = (e: any, questionIndex: any, answerIndex: any) => {
        const newAnswers = [...answers];
        newAnswers[questionIndex][answerIndex] = e.target.value;
        setAnswers(newAnswers);
    };
    const fetchwaitagentSettingDataAPI = async () => {
        if (token !== null && selectedClubInfo?.club_seq !== 0) {

            try {

                console.log(`${API_BASE_URL_ISSUER}/agentsetting/list/${selectedClubInfo?.club_seq}`)
                const response = await fetch(
                    `${API_BASE_URL_ISSUER}/agentsetting/list/${selectedClubInfo?.club_seq}`,
                    {
                        method: "GET",

                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                // console.log("data json : " + JSON.stringify(data.data, null, 2))

                const agentSettingList = data.data.agentSettingList.filter((agentSetting: any) => !agentSetting.deviceId.startsWith("form")).sort((a: any, b: any) => {
                    return new Date(b.updated).getTime() - new Date(a.updated).getTime();
                });
                const deviceNames = agentSettingList.map((agentSetting: any) => agentSetting.deviceName);
                // console.log("업데이트되는 디바이스네임 : " + JSON.stringify(deviceNames, null, 2))
                // console.log("agentsetting 총 값 :" + JSON.stringify(agentSettingList, null, 2))
                // console.log("select에 넣을 데이터 : " + deviceNames)
                // console.log("첫번째값 : " + deviceNames[0])

                const selectedValue = deviceNames[0];
                // console.log("Selected value:  ", selectedValue);
                // console.log("전체agentsetting 데이터  : " + JSON.stringify(agentSettingList, null, 2))

                setagentsettingalldata([agentSettingList])
                // onselectedDeviceall(JSON.stringify(agentSettingList));
                setagentsettingdeviceName(deviceNames);





            } catch (error) {
                console.error("(ExcelUpload) Error fetching data:", error);
            }
        }
    };
    const QrprinttoggleModal = async (methodvalue: any) => {

        setqrprintmodalOpen(!qrprintmodalOpen);
        if (!qrprintmodalOpen) {

            // console.log("입력 method : " + methodvalue)

            const requestBody: {
                clubSeq: number;
                deviceId: string;
                method: any;
                longPeriod: boolean;
            } = {
                clubSeq: selectedClubInfo?.club_seq || 0,
                deviceId: selectdeviceid,
                method: methodvalue,
                longPeriod: true,
            };
            try {

            } catch (error) {

            }
            const response = await fetch(
                `${API_BASE_URL_ISSUER}/presentation/qrlinks`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );
            // console.log("조회 : " + JSON.stringify(requestBody));
            const data = await response.json();


            if (response.ok) {
                // console.log("내역 : " + JSON.stringify(data, null, 2))

                const jsonData = {
                    "pin": data.data.qrLinkPin,
                    "did": selectdid[0],
                    "method": methodvalue
                };

                const jsonString = JSON.stringify(jsonData);
                // console.log("qr데이터 : " + JSON.stringify(jsonData));

                setqrdata(jsonString);
                setQrlasttime(data.data.qrEndTime)
                setQrlasttimetime(data.data.qrEndTime.split(" ")[1])
                setlastdate(data.data.qrEndTime.split(" ")[0])
                // console.log("날짜확인1 : " + data.data.qrEndTime.split(" ")[0]);
                setqrLinkSeq(data.data.qrLinkSeq)

            } else {
                setqrdata("");
                const timeString = "20:00"; // 예시로 제공된 시간 문자열
                const isValidTime = /^[0-2][0-9]:[0-5][0-9]$/.test(timeString);

                if (isValidTime) {
                    setQrlasttimetime(timeString);
                } else {
                    console.error("유효하지 않은 시간 형식입니다.");
                }
                setqrLinkSeq("");
                const futureDate = dayjs().add(364, 'day').format('YYYY-MM-DD');
                setlastdate(dayjs(futureDate));
                // console.log("날짜확인2 : " + futureDate);
            }


        } else {
            setqrdata("");

            const timeString = "20:00"; // 예시로 제공된 시간 문자열
            const isValidTime = /^[0-2][0-9]:[0-5][0-9]$/.test(timeString);

            if (isValidTime) {
                const newQrlasttime = `${Qrlasttime.split(' ')[0]} ${timeString}`;
                setQrlasttimetime(newQrlasttime);
            } else {
                console.error("유효하지 않은 시간 형식입니다.");
            }
            setqrLinkSeq("");
            const futureDate = dayjs().add(364, 'day').format('YYYY-MM-DD');
            // console.log("날짜확인3 : " + futureDate);
            setlastdate(dayjs(futureDate));
        }
    };

    const handleRemoveAnswer = (questionIndex: number, answerIndex: number, type: String) => {
        if (type === "answer") {
            const newAnswers = [...answers];
            newAnswers[questionIndex] = newAnswers[questionIndex].filter((answer, index) => index !== answerIndex);
            setAnswers(newAnswers);
        } else {
            const newAnswers = [...answers];
            const filteredAnswers = newAnswers[questionIndex].filter((answer, index) => {
                // console.log("값 : " + answer);
                if (index === answerIndex && answer === "기타####") {
                    return false; // Remove the current "####기타" answer
                }
                return true; // Keep all other answers
            });
            newAnswers[questionIndex] = filteredAnswers;
            setAnswers(newAnswers);
        }

    };

    const qrcreate = async (methodvalue: any) => {
        // console.log("날짜확인1 : " + lastdate);
        const formattedDate = dayjs(lastdate).format('YYYY-MM-DD');
        // console.log("날짜확인2 : " + formattedDate);
        // console.log("시간확인 : " + Qrlasttimetime);
        const Qrlasttime1 = formattedDate + " " + Qrlasttimetime;

        setQrlasttime(Qrlasttime1)

        if (Qrlasttime1 === "" || !/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/.test(Qrlasttime1)) {
            console.log("시간 형식이 잘못되었습니다. YYYY-MM-DD HH:mm 형식으로 입력하세요.");
        } else {
            const formattedQrLastTime = Qrlasttime1.replace(" ", "T");
            // console.log("1 : " + selectedClubInfo?.club_seq)
            // console.log("2 : " + selectdeviceid)
            // console.log("3 : " + true)
            // console.log("4 : " + formattedQrLastTime)

            const postData = {
                verifierClubSeq: selectedClubInfo?.club_seq,
                deviceId: selectdeviceid,
                method: selectmethodvalue,
                longPeriod: true,
                qrEndTime: formattedQrLastTime,
            };

            console.log("입력값 : " + JSON.stringify(postData));

            const response = await fetch(`${API_BASE_URL_ISSUER}/presentation/verification/qrLinks`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(postData),
            });

            const data = await response.json();
            console.log("(waitinput) PUT 요청 성공:", JSON.stringify(data));
            if (data.code == 200) {
                console.log("qr 핀번호 : " + data.data.qrLinkPin);
                console.log("메서드확인 : " + methodvalue);
                const jsonData = {
                    "pin": data.data.qrLinkPin,
                    "did": selectdid[0],
                    "method": methodvalue
                };

                const jsonString = JSON.stringify(jsonData);

                console.log("qr데이터 : " + JSON.stringify(jsonData));
                if (qrdata === "") {
                    message.info("새QR코드를 생성했습니다.");
                } else {
                    message.info("QR코드 정보를 수정했습니다.");
                }
                setqrdata(jsonString);

            }

        }

    }
    const handleSave = async () => {
        const jsonData: { "서식": Question[] } = { "서식": [] };
        let isDuplicate = false;
        let hasError = false;
        questions.forEach((question, questionIndex) => {

            console.log("확인 : " + answers[questionIndex])
            console.log("확인1 : " + selectionModes[questionIndex])

            let inputArray: { [key: string]: string | boolean }[] = answers[questionIndex]
                .map((answer, index) => ({
                    [answer]: (index === answers[questionIndex].length - 1 && answer === "기타####") ? "false####" : false
                }))
                .reduce((acc: any[], cur) => {
                    const key = Object.keys(cur)[0];
                    if (!acc.some(item => Object.keys(item)[0] === key)) {
                        acc.push(cur);
                    } else {
                        isDuplicate = true; // 중복 발생 시 플래그 설정
                    }
                    return acc;
                }, []);






            let optiontype: 'single' | 'multi' | 'input' = 'input';

            if (type[questionIndex] === "input") {
                inputArray = [{ "value": "" }];
            }
            // 질문 유형 결정
            if (type[questionIndex] === 'single') {
                optiontype = 'single';
            } else if (type[questionIndex] === 'multi') {
                optiontype = 'multi';
            }

            const questionObj: Question = {
                "name": question,
                "input": inputArray,
                "type": optiontype
            };

            console.log(optiontype + "/" + etcAnswers.length)
            if (optiontype !== 'input') {
                const subInputs = etcAnswers.map(etcAnswer => ({ "기타####": "false####" }));
                console.log("기타 : " + JSON.stringify(subInputs, null, 2));
                inputArray.push(...subInputs);
            }

            jsonData["서식"].push(questionObj);

            if (inputArray.length == 0 || question == "") {
                hasError = true;
            }
        });

        // 출력된 JSON 객체를 콘솔에 출력

        if (isDuplicate) {
            console.log("답변이 중복되지 않게 입력해주세요.");
            alert("답변이 중복되지 않게 입력해주세요.");
            return; // 중복이면 저장을 취소하고 함수 종료
        } else {
            if (hasError) {
                console.log("답변을 입력해주세요.");
                alert("답변을 입력해주세요.");
            } else {

                console.log(JSON.stringify(jsonData, null, 2));
                console.log("Current state of questions:", questions);
                console.log("Current state of answers:", answers);
                console.log("Current state of selectionModes:", selectionModes);

                const requestBody: {
                    clubSeq: number;
                    deviceId: string;
                    deviceName: string;
                    agentSetting: string;
                } = {
                    clubSeq: selectedClubInfo?.club_seq || 0,
                    deviceId: selectformdeviceID,
                    deviceName: selectformdeviceName,
                    agentSetting: JSON.stringify(jsonData),
                };


                const response1 = await fetch(
                    `${API_BASE_URL_ISSUER}/agentsetting`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(requestBody),
                    }
                );
                console.log("변경사항 : " + JSON.stringify(requestBody));
                const data1 = await response1.json();
                if (response1.ok) {
                    console.log("data2 : " + JSON.stringify(data1, null, 2));
                    fetchWebAgentSettinglist();

                }



                setselectqrdevicename("")
                setEditedPanel(null);
                console.log('저장되었습니다.');
                message.info('저장되었습니다.');
            }

        }



    };
    const qrdevicehandleInputChange = (e: any) => {
        setnewqrdevice(e.target.value);
    };
    const typehandleModeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        settypeSelectionMode(event.target.value as 'type1' | 'type2');
        settypeSelectedItems([]); // Clear selection when mode changes
    };
    const qqrhandleSave = async () => {
        setIsButtonDisabled(true);
        if (newqrdevice == "") {
            alert('이름을 입력해주세요');
        } else {

            const response = await fetch(
                `${API_BASE_URL_ISSUER}/presentation/verifier/name/${selectedClubInfo?.club_seq}/${newqrdevice}`, // URL 문자열
                { // 옵션 객체
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            // 응답이 성공했는지 확인
            if (response.ok) {
                const data = await response.json();
                console.log("데이터확인 : " + JSON.stringify(data, null, 2));

                if (JSON.stringify(data.data.exists, null, 2) == "true") {
                    alert('중복된 이름입니다.');
                } else {
                    try {
                        const nowformattedDate = new Date().toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(/[^\d]/g, '');
                        const requestBody: {
                            did: string;
                            clubSeq: number;
                            deviceId: string;
                            deviceName: string;
                        } = {
                            did: selectdid[0],
                            clubSeq: selectedClubInfo?.club_seq || 0,
                            deviceId: "form_device." + selectdid[0] + "." + selectedClubInfo?.club_seq + "." + nowformattedDate,
                            deviceName: newqrdevice,
                        };


                        const response = await fetch(
                            `${API_BASE_URL_ISSUER}/presentation/verification/web/devices`,
                            {
                                method: "POST",
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(requestBody),
                            }
                        );
                        console.log("변경사항1 : " + JSON.stringify(requestBody));
                        const data = await response.json();
                        if (response.ok) {
                            console.log("data1 : " + JSON.stringify(data, null, 2));
                        }

                        const requestBody1: {
                            clubSeq: number;
                            deviceId: string;
                            deviceName: string;
                            agentSetting: string;
                            title: string;
                            type: string;
                        } = {
                            clubSeq: selectedClubInfo?.club_seq || 0,
                            deviceId: "form_device." + selectdid[0] + "." + selectedClubInfo?.club_seq + "." + nowformattedDate,
                            deviceName: newqrdevice,
                            agentSetting: "{\"서식\": []}",
                            title: newqrdevice,
                            type: typeselectionMode === 'type1' ? "문진" : "동의서",
                        };
                        const response1 = await fetch(
                            `${API_BASE_URL_ISSUER}/agentsetting`,
                            {
                                method: "POST",
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(requestBody1),
                            }
                        );
                        console.log("변경사항2 : " + JSON.stringify(requestBody));
                        const data1 = await response1.json();
                        if (response1.ok) {
                            console.log("data2 : " + JSON.stringify(data1, null, 2));
                        }

                    } catch (error) {

                    }


                    fetchWebAgentSettinglist();
                    fetchwaitagentSettingDataAPI();
                    setnewqrdevice("")
                }
            } else {
                console.error("응답이 실패했습니다.");
            }
        }


        setTimeout(() => {
            // 1초 후에 버튼을 다시 활성화합니다.
            setIsButtonDisabled(false);
        }, 1000);

    }
    const handleTimeChange = (time: any, timeString: any) => {
        setQrlasttimetime(timeString); // qrlasttime 상태 업데이트
    };
    const fetchWebAgentSettinglist = async () => {
        if (token !== null || selectedClubInfo?.club_seq !== 0) {
            const response = await fetch(
                `${API_BASE_URL_ISSUER}/agentsetting/list/` + selectedClubInfo?.club_seq,
                {
                    method: "GET",

                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();



            // Filter and map the items with deviceId starting with "tmp_"
            const filteredListtmp = data.data.agentSettingList.filter((item: any) => item.deviceId.startsWith("tmp_"));
            const filteredListform = data.data.agentSettingList.filter((item: any) => item.deviceId.startsWith("form_"));
            
            console.log("@@"+JSON.stringify(data,null,2))
            const extractedSymptoms = filteredListtmp.map((item: any) => JSON.parse(item.agentSetting).증상);
            const extractedRooms = filteredListtmp.map((item: any) => JSON.parse(item.agentSetting).진료실);


            // console.log("1: " + JSON.stringify(extractedSymptoms, null, 2))
            // console.log("2: " + JSON.stringify(extractedRooms, null, 2))

            setUserSymptoms(extractedSymptoms.flat());
            setUserRooms(extractedRooms.flat());
            // console.log("종이진료과리스트: " + JSON.stringify(filteredListtmp, null, 2))
            // console.log("서식리스트: " + JSON.stringify(filteredListform, null, 2))
            setwebagentsettingrowdata(filteredListtmp);
            setwebagentsettingrowdataform(filteredListform);
        }
    }
    const handleAddQuestion = () => {
        console.log("문항추가")
        const newQuestions: string[] = [...questions, '']; // 새로운 문항 추가
        const newAnswers: any[] = [...answers, []]; // 새로운 문항에 대한 답변 배열 추가
        const types: string[] = [];
        const newSelectionModes: ("single" | "multi" | "input")[] = [...selectionModes, 'single']; // 새로운 문항의 선택 모드 기본값 설정
        const type = "single";
        types.push(type);
        setType(types)
        setQuestions(newQuestions);
        setAnswers(newAnswers);
        setSelectionModes(newSelectionModes);
    };
    const handleLastDateChange = (date: dayjs.Dayjs | null) => {
        setlastdate(date); // Dayjs 형식으로 변경된 날짜 상태 업데이트
    };
    const handleQRClick = async () => {
        if (qrRef.current) {
            const canvas = await html2canvas(qrRef.current);
            canvas.toBlob(async (blob) => {
                if (blob) {
                    const item = new ClipboardItem({ 'image/png': blob });
                    await navigator.clipboard.write([item]);
                    message.info("QR 코드 이미지가 클립보드에 복사되었습니다!")
                }
            });
        }
    };
    const qrprint = async () => {
        if (qrRef.current) {
            const canvas = await html2canvas(qrRef.current);
            const dataUrl = canvas.toDataURL('image/png');

            // 새 창을 열어 이미지를 인쇄
            const printWindow = window.open('', '_blank');
            if (printWindow) {
                printWindow.document.write(`
            <html>
              <head>
                <style>
                  body { 
                    margin: 0; 
                    display: flex; 
                    justify-content: center; 
                    align-items: center; 
                    height: 100vh; 
                    width: 100vw; 
                    overflow: hidden; 
                  }
                  .qr-container {
                    position: absolute;
                    top: 50%;
                    left: 63%;
                    transform: translate(-50%, -50%);
                  }
                  img { 
                    width: 80vw; /* 수정: QR 코드 너비 조정 */
                    height: auto; 
                  }
                  @page { 
                    margin: 0; 
                  }
                </style>
              </head>
              <body>
                <div class="qr-container">
                  <img src="${dataUrl}" onload="window.print();window.close()" />
                </div>
              </body>
            </html>
          `);
                printWindow.document.close();
            }
        }
    };

    const toggleExpand = (deviceName: any) => {

        setExpandedDevice(expandedDevice === deviceName ? null : deviceName); // 클릭한 기기명에 따라 펼치기/접기 토글
        console.log("gggg")
        console.log("deviceName : " + deviceName)
        console.log("타입 : " + selectmethodvalue)
        if (selectmethodvalue === "SELF-WAITING") {
            const filterlist = webagentsettingrowdata.find(item => item.deviceName === deviceName);
            // console.log("all : " + JSON.stringify(webagentsettingrowdataform,null,2) )
            // deviceQR2가 존재하면 deviceId 출력
            if (filterlist) {
                console.log("있음")
                setselectqrdevicename(filterlist.deviceName)
                setselectdeviceid(filterlist.deviceId)


            } else {
                setselectqrdevicename("")
                setselectdeviceid("")
                setEditedPanel(null);
            }
        } else if (selectmethodvalue === "INPUT-FORM") {
            const filterlist = webagentsettingrowdataform.find(item => item.deviceName === deviceName);
            // console.log("all : " + JSON.stringify(webagentsettingrowdataform,null,2) )
            // deviceQR2가 존재하면 deviceId 출력
            if (filterlist) {
                setselectqrdevicename(filterlist.deviceName)
                setselectdeviceid(filterlist.deviceId)

                const agentSetting = JSON.parse(filterlist.agentSetting);
                const questions: Question[] = agentSetting.서식;


                setQuestionsView(questions);
            } else {
                setselectqrdevicename("")
                setselectdeviceid("")
                setEditedPanel(null);
            }
        }




        if (expandedDevice === deviceName) {
            setselectqrdevicename("")
            setselectdeviceid("")
            setEditedPanel(null);
        }


    };

    const handleEdit = (panelName: any, deviceId: string) => {
        if (deviceId.startsWith("tmp_device")) {
            // tmp_device일 경우의 처리 로직
            setEditedPanel(panelName);
            setselectformdeviceID(deviceId);
            setselectformdeviceName(panelName);

            // 추가적인 처리 로직 추가 가능
        } else if (deviceId.startsWith("form_device")) {
            // form_device일 경우의 처리 로직
            setEditedPanel(panelName);
            setselectformdeviceID(deviceId);
            setselectformdeviceName(panelName);

            // form_device일 때 추가적인 처리 로직
            // 예: 기존 값 로드 등
            const agentSetting = webagentsettingrowdataform.find((item: any) => item.deviceId === deviceId);
            if (agentSetting) {
                try {
                    const jsonData = JSON.parse(agentSetting.agentSetting);
                    const questions = jsonData.서식 || []; // 서식 배열이 존재하지 않을 경우 빈 배열로 초기화
                    console.log("서식값 : " + JSON.stringify(questions))
                    const questionNames = questions.map((question: any) => question.name);
                    // 문항 설정
                    setQuestions(questionNames);

                    const answers: string[][] = [];
                    const types: string[] = [];

                    questions.forEach((question: any) => {
                        const inputAnswers = question.input.map((inputItem: any) => Object.keys(inputItem)[0]);
                        const type = question.type;
                        inputAnswers.forEach((answer: any) => {
                            if (answer.endsWith("####")) {
                                console.log("확인 : " + answer);
                            }
                        });
                        types.push(type);
                        answers.push(inputAnswers); // 질문에 해당하는 답변 배열을 설정
                    });

                    setAnswers(answers);
                    setType(types)
                    // setSelectionModes()

                    // setEtcAnswers([...etcAnswers, '']);

                    // 기타 응답 설정
                    const etcAnswers: string[] = [];
                    questions.forEach((question: any) => {
                        if (question.subInput) {
                            Object.keys(question.subInput).forEach(key => {
                                etcAnswers.push(key);
                            });
                        }
                    });
                    setEtcAnswers(etcAnswers);
                } catch (error) {
                    console.error('JSON 파싱 오류:', error);
                    message.error('서식 데이터를 로드하는 도중 오류가 발생했습니다.');
                }
            } else {
                message.error('해당하는 디바이스 설정을 찾을 수 없습니다.');
            }

            // 추가적인 처리 로직 추가 가능
        } else {
            message.error('수정할 수 없는 디바이스입니다.');
        }
    };
    const { confirm } = Modal;
    const QRhandledelete = () => {

        confirm({
            title: 'QR삭제',
            icon: <ExclamationCircleOutlined />,
            content: '정말 삭제하시겠습니까?',
            okText: '삭제',
            okType: 'danger',
            cancelText: '취소',
            onOk() {
                fetch(`${API_BASE_URL_ISSUER}/presentation/qrlinks/${qrLinkSeq}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then((response) => {
                        if (!response.ok) {


                            throw new Error('Network response was not ok ' + response.statusText);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        console.log('Success:', data);
                        setqrdata("");
                        setQrlasttime("");



                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            },
            onCancel() {
                console.log('취소되었습니다.');
            },
        });





    }
    const onSearchClick = async () => {
        // Check if searchValue is empty
        if (!searchValue) {
            // Reset to the initial data
            setInitialData(tempexcelData);
            return;
        }

        settempexcelData(initialData);

        const foundMembers = initialData.filter((row) => {
            switch (searchOption) {
                case "회원명":
                    return row.name === searchValue;
                case "구분":
                    return row.type === searchValue;
                case "제목":
                    return row.title === searchValue;
                case "차트번호":
                    return row.chartNumber === searchValue;
                default:
                    return false;
            }
        });

        console.log(JSON.stringify(foundMembers, null, 2));
        setInitialData(foundMembers);
    };
    const handleAddAnswer = (questionIndex: number, type: string) => {

        console.log(JSON.stringify(answers, null, 2))
        const hasEtcAnswer = (answersArr: string[]) => answersArr.some(answer => answer === '기타####');
        if (hasEtcAnswer(answers[questionIndex])) {
            console.log("이미 기타#### 값이 존재합니다.");
            return;
        }

        if (type === "answer") {
            const newAnswers = [...answers];
            newAnswers[questionIndex] = [...newAnswers[questionIndex], ''];
            setAnswers(newAnswers);
        } else {
            const newAnswers = [...answers];
            newAnswers[questionIndex] = [...newAnswers[questionIndex], '기타####'];
            setAnswers(newAnswers);
        }

    };
    const fetchFormlistDetailDataAPI = async () => {
        try {
            console.log("폼 넘버 :" + selectAgentClubFormDataSeq)
            const response = await fetch(
                `${API_BASE_URL_ISSUER}/agent/form/verify/${selectAgentClubFormDataSeq}/${selectMemberDidSeq}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            console.log("서식데이터디테일 : " + JSON.stringify(data, null, 2));
            setFormlistDetailData(data.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchFormlistDataAPI = async () => {
        try {
            console.log(`${API_BASE_URL_ISSUER}/agent/form/${selectedClubInfo?.club_seq}`)
            const response = await fetch(
                `${API_BASE_URL_ISSUER}/agent/form/${selectedClubInfo?.club_seq}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();

            const formattedData = data.data.map((item: any, index: number) => ({
                index: index + 1,
                type: item.type,
                title: item.title,
                name: item.memberName,
                chartNumber: item.localName,
                birthDate: item.birth,
                medicalRecords: [
                    { date: item.questionnaireTime, info: item.title || "서식 정보 없음" },
                ],
                agentClubFormDataSeq: item.agentClubFormDataSeq,
                memberDidSeq: item.memberDidSeq,
            }));
            // console.log("@@@@서식데이터 : " + JSON.stringify(formattedData, null, 2));
            setInitialData(formattedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const onSelectChange1 = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value1 = event.target.value;
        setSelectedOption1(value1);
        setSearchOption(value1);
    };

    // const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setSearchValue(e.target.value);
    // };
    const handleModeChange = (event: React.ChangeEvent<HTMLInputElement>, questionIndex: number) => {
        const newMode = event.target.value; // 클릭된 라디오 버튼의 값(single, multi, input)
        const newTypes = [...type]; // 기존 type 배열을 복사하여 새로운 배열 생성
        newTypes[questionIndex] = newMode; // 선택된 questionIndex의 모드를 업데이트
        setType(newTypes); // 새로운 모드 배열로 상태 업데이트
    };
    const showModal = (record: any) => {
        setSelectedRow(record);
        setselectAgentClubFormDataSeq(record.agentClubFormDataSeq);
        setselectMemberDidSeq(record.memberDidSeq);
        setModalVisible(true);
    };
    const handledelete = (deviceName: any, deviceId: any) => {

        console.log("삭제할 기기 : " + deviceName);
        console.log("삭제할 클럽 : " + selectedClubInfo?.club_seq);
        console.log("삭제할 아이디 : " + deviceId);


        if (deviceId.split(".")[0] === "tmp_device" || deviceId.split(".")[0] === "form_device") {



            confirm({
                title: "서식 삭제",
                icon: <ExclamationCircleOutlined />,
                content: '정말 삭제하시겠습니까?',
                okText: '삭제',
                okType: 'danger',
                cancelText: '취소',
                onOk() {
                    const postData = {
                        clubSeq: selectedClubInfo?.club_seq,
                        deviceName: deviceName
                    };

                    fetch(`${API_BASE_URL_ISSUER}/device`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(postData)
                    })
                        .then((response) => {
                            if (!response.ok) {


                                throw new Error('Network response was not ok ' + response.statusText);
                            }
                            return response.json();
                        })
                        .then((data) => {
                            console.log('Success:', data);
                            fetchWebAgentSettinglist();
                            fetchwaitagentSettingDataAPI();


                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                },
                onCancel() {
                    console.log('취소되었습니다.');
                },
            });




        } else {
            message.error('삭제할수없습니다.');
        }



    }
    const closeModal = () => {
        setModalVisible(false);
    };
    const QQrtoggleModal = () => {
        setSelectMethodValue("INPUT-FORM")
        setQQrModalOpen(!QQrmodalOpen);
        if (!QQrmodalOpen == false) {
            setExpandedDevice(null);
            setEditedPanel(null);
        }

    };
    const columns = [
        { title: "순서", dataIndex: "index", key: "index" },
        { title: "구분", dataIndex: "type", key: "type" },
        { title: "제목", dataIndex: "title", key: "title" },
        { title: "이름", dataIndex: "name", key: "name" },
        { title: "차트 번호", dataIndex: "chartNumber", key: "chartNumber" },
        { title: "생년월일", dataIndex: "birthDate", key: "birthDate" },
        {
            title: "서식 날짜/시간",
            dataIndex: "medicalRecords",
            key: "medicalRecords",
            render: (medicalRecords: any[]) => (
                <>
                    {medicalRecords.map((record, index) => (
                        <div key={index}>
                            <Button type="link" onClick={() => showModal(record)}>
                                {record.date}
                            </Button>
                        </div>
                    ))}
                </>
            ),
        },
    ];

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "20px",
            }}
        >
            <div style={{ fontSize: "24px" }}>| { } 서식</div>
            <div
                style={{
                    padding: "5px",
                    // border: "1px solid #CACACA",
                    marginLeft: "50px",
                    marginBottom: "55px",
                    width: width <= 1600 ? "300px" : "700px",
                    marginTop: "50px",
                }}
            >
                {/* <select
                    value={selectedOption1}
                    onChange={onSelectChange1}
                    style={{
                        border: "none",
                        borderRadius: "5px",
                        backgroundColor: "rgba(255, 255, 255, 0)",
                        fontSize: "16px",
                        cursor: "pointer",
                        outline: "none",
                    }}
                >
                    <option value="name" style={{ color: "black", borderRadius: "5px" }}>
                        회원명
                    </option>
                    <option value="phone" style={{ color: "black", borderRadius: "5px" }}>
                        핸드폰번호
                    </option>
                    <option
                        value="memberGrade"
                        style={{ color: "black", borderRadius: "5px" }}
                    >
                        회원구분
                    </option>
                    <option
                        value="localname"
                        style={{ color: "black", borderRadius: "5px" }}
                    >
                        아이디
                    </option>
                </select>
                |
                <Input
                    value={searchValue}
                    onChange={onInputChange}
                    style={{
                        width: width <= 1600 ? "200px" : "490px",
                        height: "30px",
                        marginRight: "10px",
                        border: "none",
                    }}
                    placeholder="회원 검색"
                    prefix={<SearchOutlined style={{ color: "rgba(0,0,0,.45)" }} />}
                />
                <button
                    style={{
                        cursor: "pointer",
                        width: "50px",
                        height: "30px",
                        borderRadius: "10px",
                        backgroundColor: "#ffff",
                        border: "1px solid #2D5478",
                        color: "#000",
                    }}
                    onClick={onSearchClick}
                >
                    찾기
                </button> */}
            </div>
            <div style={{ width: "50%", height: "100%" }}>
                <div style={{ display: 'flex' }}>
                    <div
                        style={{
                            textAlign: "left",
                            fontSize: "30px",
                            paddingLeft: "50px",
                        }}
                    >
                        서식작성 명단
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', width: "300px" }}>
                        <img
                            src="asset/img/qqr.png"
                            alt="QR Icon"

                            onClick={QQrtoggleModal}

                            // className={isRotating ? "rotate" : ""}
                            style={{
                                width: width <= 1600 ? "20px" : "40px",
                                height: width <= 1600 ? "20px" : "40px",
                                cursor: "pointer",
                                marginLeft: "10px",

                            }}
                        />
                        <span style={{ fontSize: '15px', marginLeft: "10px" }}>서식</span>
                    </div>
                </div>

                <div
                    style={{
                        width: "100%",
                        height: width <= 1600 ? "200px" : "800px",
                        marginTop: "30px",
                        marginLeft: "40px",
                    }}
                >
                    <Table
                        dataSource={initialData}
                        columns={columns}
                        rowKey="index"
                        onRow={(record) => ({
                            onClick: () => {
                                // console.log(`Selected agentClubFormDataSeq: ${record.agentClubFormDataSeq}`);
                                // console.log(`Selected memberDidSeq: ${record.memberDidSeq}`);
                                setselectAgentClubFormDataSeq(record.agentClubFormDataSeq);
                                setselectMemberDidSeq(record.memberDidSeq);
                                showModal(record);
                            },
                        })}
                    />
                    <Modal
                        title={`${selectedRow?.name}의 서식 정보`}
                        visible={modalVisible}
                        onCancel={closeModal}
                        footer={null}
                    >
                        {formlistDetailData && (
                            <>
                                <p>차트 번호: {selectedRow?.chartNumber}</p>
                                <p>생년월일: {selectedRow?.birthDate}</p>
                                <div>
                                    <p>서식 내용:</p>
                                    {formlistDetailData.questionnaire && (() => {
                                        const parsedQuestionnaire = JSON.parse(formlistDetailData.questionnaire);
                                        return (
                                            <ul>
                                                {parsedQuestionnaire.서식.map((question: any, index: number) => (
                                                    <li key={index}>
                                                        <strong>{question.name}:</strong>&nbsp;
                                                        <span>
                                                            {question.type === "input" ? (
                                                                question.input[0].value
                                                            ) : (
                                                                question.input.map((inputItem: any, idx: number) => {
                                                                    const [key, value] = Object.entries(inputItem)[0];
                                                                    if (key === "기타####" && typeof value === "string") {
                                                                        const splitValue = value.split("####");
                                                                        return splitValue[1] ? `기타(${splitValue[1]})` : "";
                                                                    } else if (value === true) {
                                                                        return key;
                                                                    }
                                                                    return null;
                                                                }).filter(Boolean).join(", ")
                                                            )}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        );
                                    })()}
                                </div>
                            </>
                        )}
                    </Modal>
                </div>
            </div>
            {qrprintmodalOpen && (

                <Modal

                    title="QR 관리"
                    style={{ fontSize: "18px", borderRadius: "20px" }}
                    open={qrprintmodalOpen}

                    // onCancel={() => setWaitIsModalVisible(false)}
                    onCancel={QrprinttoggleModal}
                    width={800}
                    footer={[
                        <div key="button-container" style={{ textAlign: "center" }}>
                            <Button
                                type="primary"
                                style={{ marginRight: "8px" }}
                                onClick={() => qrcreate("INPUT-FORM")}
                            >
                                {qrdata === "" ? "QR 생성" : "마감일 수정"}
                            </Button>

                            <Button type="primary" style={{ marginRight: "8px", display: qrdata === "" ? "none" : "", }} onClick={() => qrprint()}>인쇄</Button>
                            <Button danger style={{ marginRight: "8px", display: qrdata === "" ? "none" : "", }} onClick={() => QRhandledelete()}>삭제</Button>
                        </div>
                    ]}
                >
                    <div style={{ marginBottom: "16px" }}>



                        <div ref={qrRef} onClick={handleQRClick} style={{ cursor: 'pointer' }}>
                            <QRCode value={qrdata} size={500} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "8px" }}>
                            <div style={{ marginRight: "8px", width: "300px" }}>마감일자</div>
                            {/* 2024-05-14T17:15:00 */}
                        </div>
                        <div style={{ display: "flex", marginBottom: "8px" }}>
                            <DatePicker
                                clearIcon
                                // placeholder={lastdate+""}
                                placeholder="마감일을 선택해주세요"
                                value={lastdate ? dayjs(lastdate, 'YYYY-MM-DD') : null}
                                onChange={handleLastDateChange}
                                style={{ marginRight: "8px", width: "150px" }}
                            />

                            <TimePicker
                                changeOnBlur
                                style={{ marginRight: "8px", width: "200px" }}
                                value={dayjs(Qrlasttimetime, 'HH:mm')} // 시간
                                format="HH:mm"
                                onChange={handleTimeChange}
                            />

                        </div>
                    </div>
                </Modal>

            )}
            {QQrmodalOpen && (
                <div>
                    {/* 모달 */}
                    <Modal
                        title="서식 관리"
                        style={{ fontSize: "18px", borderRadius: "20px" }}
                        open={QQrmodalOpen}
                        onCancel={QQrtoggleModal}
                        width={600}
                        footer={[]} // footer는 빈 배열로 설정하여 하단에 버튼을 따로 추가합니다.
                    >
                        {/* 기기등록 파트 */}
                        <div style={{ marginBottom: "16px", borderBottom: "1px solid black", padding: "16px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                                <div style={{ fontWeight: "bold", marginRight: "8px", width: "100px" }}>
                                    서식 제목
                                </div>
                                <Input
                                    value={newqrdevice}
                                    onChange={qrdevicehandleInputChange}
                                    style={{ flex: "1" }}
                                />
                            </div>

                            <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                                <div style={{ fontWeight: "bold", marginRight: "8px", width: "100px" }}>
                                    타입
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                        <input
                                            type="radio"
                                            value="type1"
                                            checked={typeselectionMode === 'type1'}
                                            onChange={typehandleModeChange}
                                        />
                                        문진
                                    </label>
                                    <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                        <input
                                            type="radio"
                                            value="type2"
                                            checked={typeselectionMode === 'type2'}
                                            onChange={typehandleModeChange}
                                        />
                                        동의서
                                    </label>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={qqrhandleSave}
                                    style={{
                                        width: "120px",
                                        height: "36px",
                                        borderRadius: "10px",
                                        color: "#fff",
                                        background: "#2D5478",
                                        borderColor: "#2D5478",
                                    }}
                                    disabled={isButtonDisabled}
                                >
                                    등록
                                </Button>
                            </div>
                        </div>



                        {webagentsettingrowdataform.sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime())
                            .filter((agentSetting: any) => agentSetting.deviceId.startsWith("form"))
                            .map((agentSetting: any, index: any) => (
                                <div key={index} style={{ marginBottom: "16px" }}>
                                    <div style={{ marginBottom: "16px", padding: "8px", border: "1px solid #e0e0e0", borderRadius: "8px" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px", cursor: 'pointer' }} onClick={() => toggleExpand(agentSetting.deviceName)}>
                                            <div style={{ fontWeight: "bold" }}>{agentSetting.deviceName}</div>



                                            {/*  */}
                                        </div>
                                        {expandedDevice === agentSetting.deviceName && editedPanel !== agentSetting.deviceName && (
                                            <>
                                                <div style={{ marginBottom: "8px" }}>
                                                    {questionsView.map((question, index) => (
                                                        question.name && (
                                                            <div key={index}>
                                                                <p>{`문항 ${index + 1}: ${question.name}, 타입: ${question.type === 'single' ? '단일형' :
                                                                    question.type === 'multi' ? '다중형' :
                                                                        question.type === 'input' ? '단답형' : ''
                                                                    } `}</p>
                                                            </div>
                                                        )
                                                    ))}
                                                </div>

                                                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>

                                                    {agentSetting.deviceId.split(".")[0] === "form_device" && (
                                                        <div>
                                                            <Button type="primary" style={{ marginRight: "8px" }} onClick={() => QrprinttoggleModal("INPUT-FORM")}>서식 QR 관리</Button>
                                                            <Button type="primary" style={{ marginRight: "8px" }} onClick={() => handleEdit(agentSetting.deviceName, agentSetting.deviceId)}>
                                                                수정
                                                            </Button>
                                                            <Button danger onClick={() => handledelete(agentSetting.deviceName, agentSetting.deviceId)}>
                                                                삭제
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}











                                        {
                                            expandedDevice === agentSetting.deviceName && editedPanel === agentSetting.deviceName && (
                                                <div>
                                                    {
                                                        expandedDevice === agentSetting.deviceName && editedPanel === agentSetting.deviceName && (
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                {questions.map((question, questionIndex) => (
                                                                    <div key={questionIndex} style={{ border: '1px solid gray', padding: '10px', marginBottom: '16px' }}>
                                                                        {/* 문항 입력 */}
                                                                        <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                                                                            <div style={{ fontWeight: 'bold', marginRight: '8px' }}>문항</div>
                                                                            <Input
                                                                                placeholder="문항을 입력해주세요."
                                                                                style={{ flex: 1, marginRight: '8px', width: '215px' }}
                                                                                value={question}
                                                                                onChange={(e) => {
                                                                                    const newQuestions = [...questions];
                                                                                    newQuestions[questionIndex] = e.target.value;
                                                                                    setQuestions(newQuestions);
                                                                                }}
                                                                            />
                                                                        </div>



                                                                        {/* 답변 입력 */}
                                                                        <div style={{ marginBottom: '8px', display: 'flex', flexDirection: 'column' }}>
                                                                            <div style={{ marginBottom: '8px' }}>답변</div>

                                                                            {type[questionIndex] === 'input' ? (
                                                                                <div key={index} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                                                                                    <Input
                                                                                        placeholder="단답형"
                                                                                        style={{ marginRight: '8px', width: '300px' }}
                                                                                        value="단답형" // 수정할 수 없는 상태로 표시
                                                                                        disabled // 수정 불가능하도록 설정
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                answers[questionIndex].map((answer: any, answerIndex: any) => (
                                                                                    <div key={answerIndex} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                                                                                        {answer.endsWith('####') ? (
                                                                                            <div key={index} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                                                                                                <Input
                                                                                                    placeholder="기타..."
                                                                                                    style={{ marginRight: '8px', width: '300px' }}
                                                                                                    value="기타..." // 수정할 수 없는 상태로 표시
                                                                                                    disabled // 수정 불가능하도록 설정
                                                                                                />
                                                                                                <Button
                                                                                                    type="primary"
                                                                                                    shape="circle"
                                                                                                    style={{ width: "40px", height: "40px" }}
                                                                                                    icon={<MinusOutlined />}
                                                                                                    onClick={() => handleRemoveAnswer(questionIndex, answerIndex, "etcanswer")}
                                                                                                />
                                                                                            </div>
                                                                                        ) : (
                                                                                            <>
                                                                                                <Input
                                                                                                    placeholder="답변을 입력해주세요."
                                                                                                    style={{ marginRight: '8px', width: '300px' }}
                                                                                                    value={answer}
                                                                                                    onChange={(e) => handleAnswerChange(e, questionIndex, answerIndex)}
                                                                                                />
                                                                                                <Button
                                                                                                    type="primary"
                                                                                                    shape="circle"
                                                                                                    style={{ width: "40px", height: "40px" }}
                                                                                                    icon={<MinusOutlined />}
                                                                                                    onClick={() => handleRemoveAnswer(questionIndex, answerIndex, "answer")}
                                                                                                />
                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                ))
                                                                            )}


                                                                            {type[questionIndex] === 'input' ? (
                                                                                <span></span>
                                                                            ) : (
                                                                                <div>
                                                                                    <div
                                                                                        onClick={() => handleAddAnswer(questionIndex, "answer")}
                                                                                        style={{
                                                                                            cursor: 'pointer',
                                                                                            marginRight: '8px',
                                                                                            height: '40px',
                                                                                            marginLeft: '30px',
                                                                                            marginBottom: '30px',
                                                                                            display: 'inline-flex',
                                                                                            color: "gray",
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                        }}
                                                                                    >
                                                                                        답변 추가
                                                                                    </div>
                                                                                    또는
                                                                                    <div
                                                                                        onClick={() => handleAddAnswer(questionIndex, "etcanswer")}

                                                                                        style={{
                                                                                            cursor: 'pointer',
                                                                                            marginRight: '8px',
                                                                                            height: '40px',
                                                                                            marginLeft: '10px',
                                                                                            marginBottom: '30px',
                                                                                            display: 'inline-flex',
                                                                                            color: "blue",
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                        }}
                                                                                    >
                                                                                        '기타' 추가
                                                                                    </div>

                                                                                </div>
                                                                            )}

                                                                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>

                                                                                <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        value="single"
                                                                                        checked={type[questionIndex] === 'single'}
                                                                                        onChange={(e) => handleModeChange(e, questionIndex)}
                                                                                    />
                                                                                    단일선택
                                                                                </label>
                                                                                <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        value="multi"
                                                                                        checked={type[questionIndex] === 'multi'}
                                                                                        onChange={(e) => handleModeChange(e, questionIndex)}
                                                                                    />
                                                                                    다중선택
                                                                                </label>
                                                                                <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        value="input"
                                                                                        checked={type[questionIndex] === 'input'}
                                                                                        onChange={(e) => handleModeChange(e, questionIndex)}
                                                                                    />
                                                                                    단답형
                                                                                </label>
                                                                            </div>

                                                                            {/* 저장 버튼 */}
                                                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                <Button
                                                                                    type="primary"
                                                                                    style={{ width: '120px', height: '36px' }}
                                                                                    onClick={handleSave}
                                                                                >
                                                                                    저장
                                                                                </Button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}

                                                                {/* 문항 추가 버튼 */}
                                                                <div style={{ display: 'grid', placeItems: 'center' }}>
                                                                    <Button
                                                                        type="primary"
                                                                        shape="circle"
                                                                        icon={<PlusOutlined />}
                                                                        onClick={handleAddQuestion} // 문항 추가 버튼 클릭 시 처리하는 함수
                                                                        style={{ marginRight: '8px', marginTop: "30px", width: '40px', height: '40px', marginBottom: "30px" }}
                                                                    />
                                                                </div>

                                                                {/* 답변 입력 방식 선택 */}

                                                            </div>
                                                        )}
                                                </div>
                                            )
                                        }







                                    </div>
                                </div>
                            ))}

                    </Modal>
                </div>
            )}
        </div>
    );
};

export default FormlistView;
